import { render, staticRenderFns } from "./gerenKS.vue?vue&type=template&id=91609c6e&"
import script from "./gerenKS.vue?vue&type=script&lang=js&"
export * from "./gerenKS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports